import ProfileIdentityCardHeader from './ProfileIdentityCardHeader'

export default ProfileIdentityCardHeader
export * from './ProfileIdentityCardHeader'
